module.exports = __webpack_public_path__ + "img/history-icon.cec27c24.svg";